import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RequestStartText } from 'utils/constant';
import { Images } from 'assets/images';
import { ROUTES } from 'utils/routeNames';
import {
  IntroductionText,
  StartRequestContent,
  IconAndButtonForStarting,
  StartYourTripWrapper,
  StartTripButton,
  ImgLine,
  DestinationIcon,
} from './styled';

export const StartRequest = ({ handleClick }) => {
  const { user } = useSelector(({ auth }) => auth);
  const navigate = useNavigate();

  const navigateToQuestions = () => {
    if (
      user?.data?.birthdate === null ||
      user?.data?.country === null ||
      user?.data?.city === null ||
      user?.city?.gender === null
    ) {
      handleClick();
    } else {
      navigate(ROUTES.QUESTIONS);
    }
  };

  return (
    <StartRequestContent>
      <IntroductionText>{RequestStartText}</IntroductionText>
      <IconAndButtonForStarting>
        <DestinationIcon src={Images.destinationAmice} alt="dest" />
        <StartYourTripWrapper>
          <StartTripButton onClick={navigateToQuestions}>
            Start Your Trip
            <ImgLine src={Images.buttonLine} />
          </StartTripButton>
        </StartYourTripWrapper>
      </IconAndButtonForStarting>
    </StartRequestContent>
  );
};
